angular
  .module('countriesApp')
  .service('JobsService', [
    'RequestService',
    '$q',
    'alertHandlingService',
    'JobModel',
    function (Request, $q, AlertHandling, JobModel) {
      const jobs = {
        'data': null,
        'total': null
      };
      let country = null;

      /**
       * Performs a request to jobs API endpoint with the given Country
       * It stores the response data in this service, also handles if there is an error
       *
       * @param {number} id - Country id
       *
       * @returns {object} - Request promise object
       */
      const request = id => {
        country = id;

        return Request.getCountryJobs(id)
          .then(response => {
            const results = response.data;

            jobs.total = results.total;
            jobs.data = results.data.map(job => new JobModel(job));

            return jobs;
          })
          .catch(() => {
            AlertHandling.showGenericErrorMessage();

            return jobs;
          });
      };

      /**
       * Performs a request to the API to get the jobs list if the promise is not already running
       *
       * @param {number} id - Country id
       *
       * @returns {object} - Country promise object
       */
      const get = id => {
        if (jobs && country === id) {
          return $q(resolve => resolve(jobs));
        }

        return request(id);
      };

      return {
        get
      };
    }
  ]);
